
const uploadApiEndpoint = "https://drop.manateepao.gov/api/up";

const upload_domain = "\\\\demeter.manateepao.com\\Website_Uploads";
const dropArea = document.getElementById('pao-drop-area');
const fileInput = document.getElementById('pao-file-input');
const fileList = document.getElementById('pao-file-list');
const browseLink = document.getElementById('pao-browse-link');
const statusMessage = document.getElementById("status-message");
const errorMessageDiv = document.getElementById('error-message');



  const ALLOWED_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
    'image/tiff',
    'image/webp',
];


const MAX_FILE_SIZE = 65 * 1024 * 1024;
const falconUploadTimeMultiplier = 4.5;

let totalFileSize = 0;
let bandwidthDetected = false;
let detectedBandwidthMbps = 0;
let allowPreviewThumbnail;

let uncUploadedPaths = [];
let uploadedFiles = [];
let selectedFiles = []; 

const UNABLE_TO_UPLOAD_MESSAGE = "We were unable to upload your file(s) at this time. You can still submit your Property Damage Survey and Email your files directly. We apologize for the inconvenience.";

var negative_verdicts = ['INVALID FILE EXTENSION', 'FILE ID UNKNOWN', 'FILE INFECTED'];
var positive_verdicts = ['SKIPPED SCAN','FILE SAFE'];

const delay = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

function pruneFilesToUploadAboveMaxSize() {

    let input = document.getElementById('pao-file-input');

    let files = Array.from(input.files);

    files.sort((a, b) => a.size - b.size);

    let totalSize = 0;

    const newDataTransfer = new DataTransfer();

    for (let file of files) {
        if (totalSize + file.size <= MAX_FILE_SIZE) {  
            totalSize += file.size;  
            newDataTransfer.items.add(file);  
        } else {
            break;
        }
    }
    return newDataTransfer;
}

async function handleFilesAsync(files) {

    showScanningIndicator();

    let message = "Your files are being checked for safety. This may take up to 1 minute. Please wait.";
    showStatusMessage(message, "alert-primary");

    totalFileSize = 0;

    Array.from(files).forEach(file => {
        totalFileSize += file.size;
    });

    let input = document.getElementById('pao-file-input');

    const fileSizeErrorLabel = document.getElementById('fileSizeErrorLabel');
    if (totalFileSize > MAX_FILE_SIZE) {
        if (!fileSizeErrorLabel) {
            const newLabel = document.createElement('div');
            newLabel.id = 'fileSizeErrorLabel';
            newLabel.style.color = 'red';
            newLabel.textContent = "The combined size of all selected files exceeds the 65 MB upload limit. Some files were not included.";
            document.getElementById('file_size_error_container').appendChild(newLabel);
        }
        input.files = pruneFilesToUploadAboveMaxSize().files;
    } else {
        input.files = files;
    }

    if (fileSizeErrorLabel) {
        fileSizeErrorLabel.remove();
    }

    let newDataTransfer = new DataTransfer();

    let unsafe_files = [];

    const fileArray = Array.from(input.files);

    for await (const file of fileArray) { 


        let file_type = file.type.toLowerCase();
        if (!ALLOWED_MIME_TYPES.includes(file_type)) {
            continue; 
        }

        newDataTransfer.items.add(file);

        allowPreviewThumbnail = false;


        let result = await processFileAsync(file);

        if (result === null || result === undefined || result?.quotaReached === "CLOSED") {
            disableDamageFormFileUpload(error, UNABLE_TO_UPLOAD_MESSAGE);
            return;
        }

        let file_scan_result = {};

        if (result?.statusCode) {
            file_scan_result.statusCode = result.statusCode;
        }

        if (result?.scanVerdict) {

            file_scan_result.verdict = result.scanVerdict;

            if (negative_verdicts.includes(result.scanVerdict.toUpperCase())) {
                file_scan_result.file_clean = false;
            }

            if (positive_verdicts.includes(result.scanVerdict.toUpperCase())) {
                if (result?.webUploadUNC) {
                    uncUploadedPaths.push(`${upload_domain}\\${result.webUploadUNC}`);
                    file_scan_result.file_clean = true;
                }
                if (result?.JobId) {
                    file_scan_result.file_jobid = result?.JobId;
                }
                allowPreviewThumbnail = true;
            }
        }

        const fileItem = document.createElement('div');
        fileItem.classList.add('file-item');

        let previewElement;

        if (file.type.startsWith('image/')) {

            if (allowPreviewThumbnail) {
                if (file.type === 'image/tiff') {
                    previewElement = document.createElement('canvas');
                    fileItem.appendChild(previewElement);
                    renderTiffPreview(file, previewElement);
                } else {

                    previewElement = document.createElement('img');

                    const fileReader = new FileReader();
                    fileReader.onload = function (e) {
                        previewElement.src = e.target.result;
                        fileItem.insertBefore(previewElement, fileItem.querySelector('p'));
                    };
                    fileReader.readAsDataURL(file);
                }
            } else {
                previewElement = document.createElement('span');
                previewElement?.classList.add('bi-x-circle');
                fileItem.classList.add('unsafe');
                fileItem.insertBefore(previewElement, fileItem.querySelector('p'));
            }
        }

        else if (file.type === 'application/pdf') {

            if (allowPreviewThumbnail) {
                previewElement = document.createElement('canvas');
                fileItem.appendChild(previewElement);
                renderPdfPreview(file, previewElement);

            } else {
                previewElement = document.createElement('span');
                fileItem.classList.add('unsafe');
                fileItem.insertBefore(previewElement, fileItem.querySelector('p'));
            }
        }
        else if (file.type === 'text/plain') {
            previewElement = document.createElement('p');
            const fileReader = new FileReader();
            fileReader.onload = function (e) {
                previewElement.innerText = e.target.result.substring(0, 50);
                fileItem.insertBefore(previewElement, fileItem.querySelector('p'));
            };
            fileReader.readAsText(file);
        }
        else if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            previewElement = document.createElement('i');
            previewElement.classList.add('fas', 'fa-file-word'); 
            fileItem.appendChild(previewElement);
        }
        else {
            previewElement = document.createElement('i');
            previewElement.classList.add('fas', 'fa-file'); 
            fileItem.appendChild(previewElement);
        }

        const fileName = document.createElement('p');
        fileName.classList.add('file-name');
        fileName.innerText = file.name;
        fileItem.appendChild(fileName);

        const fileSize = document.createElement('p');
        fileSize.classList.add('file-size');
        fileSize.innerText = formatBytes(file.size);

        fileItem.appendChild(fileSize);
        if (allowPreviewThumbnail) {

            const deleteBtn = document.createElement('button');
            deleteBtn.classList.add('trash');
            deleteBtn.onclick = function () {
                fileItem.remove();
                updateFileInputAfterDeleted(fileItem);
            };
            fileItem.appendChild(deleteBtn);


        }
        fileList.appendChild(fileItem);

        if (!allowPreviewThumbnail) {
            unsafe_files.push(file.name);
            updateFileInputAfterDeleted(fileItem);
        }

        if (allowPreviewThumbnail) {
            selectedFiles.push(file);
            displayTotalFileSize();
        }

        await delay(300); 
    }

    input.files = newDataTransfer.files;


    statusMessage.innerHTML = "";
    statusMessage.classList.add("d-none");

    hideScanningIndicator();


    if (unsafe_files.length > 0) {

        let badfileList = `<ol class="unsafe-file-list mt-2">` + unsafe_files.map(fn => `<li>${fn}</li>`).join('') + `</ol>`;

        let msg = `We detected that the file(s) you attempted to upload may pose a security 
        risk and were therefore blocked. If you believe this is an error, please double-check the file format and 
        ensure it's free from any malicious content.<br />` + badfileList;


        const unsafeDiv = document.getElementById('pao-unsafe-file-list');
        unsafeDiv.innerHTML = msg;

        unsafeDiv.classList.add('alert-danger');
        unsafeDiv.classList.remove('d-none');

        document.getElementById("errorblock").scrollIntoView({
            behavior: "smooth"  
        });        
    }
}

function showStatusMessage(message, alert_type) {
    statusMessage.innerHTML = message;
    statusMessage.classList.add(alert_type)
    statusMessage.classList.remove("d-none");
}

async function processFileAsync(file) {

    const fileSizeMB = file.size / (1024 * 1024); 

    try {
        if (!bandwidthDetected) {
            const bandwidthMbps = await detectBandwidthAsync();
            if (bandwidthMbps > 0) {
                bandwidthDetected = true;
                detectedBandwidthMbps = bandwidthMbps; 
            }
        }


        return await scanFileAsync(file, fileSizeMB, detectedBandwidthMbps);

    } catch (error) {
        console.error("Error during file scan:", error);
        return false; 
    }
}

async function detectBandwidthAsync() {
    const testUrl = '/wp-content/themes/frontier-child/images/bandwidth-test-image.png';

    return new Promise((resolve, reject) => {
        const image = new Image();
        const startTime = Date.now(); 

        fetch(testUrl, { method: 'HEAD' })
            .then(response => {
                const fileSizeBytes = parseInt(response.headers.get('Content-Length'), 10);

                if (isNaN(fileSizeBytes)) {
                    throw new Error("Could not determine file size from headers.");
                }
                image.onload = () => {
                    const endTime = Date.now(); 
                    const duration = (endTime - startTime) / 1000; 

                    const bandwidthMbps = (fileSizeBytes * 8) / (duration * 1024 * 1024); 
                    resolve(bandwidthMbps);
                };
                image.onerror = () => {
                    reject(new Error("Error loading the test image."));
                };
                image.src = testUrl + '?' + new Date().getTime(); 
            })
            .catch(error => {
                reject(error); 
            });
    });
}

async function doUploadEstimate() {
    const uploadTime = estimateUploadTime(fileSizeMB, bandwidthMbps);

    const falconUploadTime = uploadTime.minutes * 60 + uploadTime.seconds; 
    const totalUploadTimeWithFalcon = falconUploadTime + (fileSizeMB * falconUploadTimeMultiplier); 

    const adjustedMinutes = Math.floor(totalUploadTimeWithFalcon / 60);
    const adjustedSeconds = Math.round(totalUploadTimeWithFalcon % 60);

    const formattedFileSize = formatFileSize(file.size);

    uploadedFiles.push({
        name: file.name,
        size: formattedFileSize,
        uploadTime: `${adjustedMinutes} minute(s) and ${adjustedSeconds} second(s)`
    });

    let estimated_upload_time = formatEstimatedUploadTimeMessage({ minutes: adjustedMinutes, seconds: adjustedSeconds });

    console.log(`Detected bandwidth: ${bandwidthMbps.toFixed(2)} Mbps`);
    console.log(estimated_upload_time);

    const fileEstimatedUploadTime = document.getElementById("file_estimated_upload_time");
    file_estimated_upload_time.className = "file-info-estimate file-info-estimate-icon";
    fileEstimatedUploadTime.textContent = estimated_upload_time;
}

async function scanFileAsync(file, fileSizeMB, bandwidthMbps) {
    try {



                        const tf = await isFileScanApiAvailableAsync();
            if(tf) {
                return await uploadFileAsync(file, "scan");
            } else {
                return false;
            }

    } catch (error) {
        console.error(error.message);
        return false;
    }
}

async function isFileScanApiAvailableAsync() {
    try {
        const response = await fetch(`${uploadApiEndpoint}/health`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            }
        });

        let data = await response.json();


        if (response?.status !== 200) {
            const dropArea = document.getElementById('pao-drop-area');
            if (dropArea)
                dropArea.style.display = 'none';
            disableDamageFormFileUpload(data);
            return false;
        }


        return true;

    } catch (error) {

        if (error instanceof TypeError && error.message === 'Failed to fetch') {
        } else {
        }        
        disableDamageFormFileUpload(error);
        return false;
    }
}







function disableDamageFormFileUpload(data, message) {
    if (data)
        console.error(data?.message);

    let uploadButton = document.getElementById('pao-file-input');
    if (uploadButton) {
        uploadButton.disabled = true;
        if (!message) {
            let submsg = "";
            let totalBytes = selectedFiles.reduce((total, file) => total + file.size, 0);
            if (totalBytes > 0)
                submsg = "However, any files you've already uploaded will be received successfully. "

            message = `We are currently unable to upload files through the survey. ${submsg}Please submit your survey and then send supporting documentation, including your Parcel ID, to damagereport@manateepao.gov`;
        }
        hideScanningIndicator();
        showStatusMessage(message, "alert-warning");
    }
}



async function uploadFileAsync(file, route_action = "scan") {

    const fileFormData = new FormData();
    fileFormData.append("file", file);
    fileFormData.append("parid", pao_parcel_id.value);

    let testMode = document.getElementById('test-mode');
    if (testMode) {
        const da = testMode.getAttribute('data-test-value');
        const isTestModeActive = da === "true";
        fileFormData.append("IsTest", isTestModeActive);
    }

    try {

        const response = await fetch(`${uploadApiEndpoint}/${route_action}`, {
            method: "POST",
            body: fileFormData
        });

        return await response.json();

    } catch (error) {
        disableDamageFormFileUpload(error, UNABLE_TO_UPLOAD_MESSAGE);
    }
    return null;
}

function estimateUploadTime(fileSizeMB, bandwidthMbps) {
    const bandwidthMBps = bandwidthMbps / 8;  

    const fileSizeBytes = fileSizeMB * 1024 * 1024; 

    const uploadTimeSeconds = fileSizeBytes / (bandwidthMBps * 1024 * 1024);

    const minutes = Math.floor(uploadTimeSeconds / 60);
    const seconds = Math.floor(uploadTimeSeconds % 60);
    return { minutes, seconds };
}

function renderTiffPreview(file, canvas) {
    const reader = new FileReader();
    reader.onload = function (e) {
        const arrayBuffer = e.target.result;

        const tiff = new Tiff({ buffer: arrayBuffer });

        canvas.width = tiff.width();
        canvas.height = tiff.height();

        const ctx = canvas.getContext('2d');

        const image = tiff.toCanvas();
        ctx.drawImage(image, 0, 0);
    };
    reader.readAsArrayBuffer(file); 
}

function renderPdfPreview(file, canvas) {
    const reader = new FileReader();
    reader.onload = function (e) {
        const pdfData = new Uint8Array(e.target.result);
        pdfjsLib.getDocument(pdfData).promise.then(function (pdf) {
            pdf.getPage(1).then(function (page) {
                const scale = 0.5;
                const viewport = page.getViewport({ scale: scale });
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                const context = canvas.getContext('2d');
                page.render({ canvasContext: context, viewport: viewport });
            });
        });
    };
    reader.readAsArrayBuffer(file);
}

function formatBytes(bytes) {
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let i = 0;
    while (bytes >= 1024 && i < units.length - 1) {
        bytes /= 1024;
        i++;
    }
    return bytes.toFixed(2) + ' ' + units[i];
}

function formatEstimatedUploadTimeMessage(uploadTime) {
    let estimated_upload_time = "Estimated upload time: ";

    if (uploadTime.minutes > 0) {
        estimated_upload_time += `${uploadTime.minutes} minute(s)`;
    }

    if (uploadTime.minutes > 0 && uploadTime.seconds > 0) {
        estimated_upload_time += " and ";
    }

    if (uploadTime.seconds > 0) {
        estimated_upload_time += `${uploadTime.seconds} second(s)`;
    }

    if (uploadTime.minutes === 0 && uploadTime.seconds === 0) {
        estimated_upload_time += "less than a second";
    }

    return estimated_upload_time;
}

function notifyInvalidFileType(files) {

    const _lbl = document.getElementById('file-not-supported-label');
    if (_lbl)
        _lbl.remove();

    let errorMessage = document.getElementById('error-message');

    errorMessage.classList.add('d-none');

    for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let fileType = file.type;

        if (!ALLOWED_MIME_TYPES.includes(fileType)) {

            statusMessage.innerHTML = "";
            statusMessage.classList.add("d-none");

            const dv = document.createElement('div');
            dv.id = 'file-not-supported-label';
            dv.setAttribute('aria-labelledby', 'file-not-supported-label');
            dv.setAttribute('aria-describedby', 'file-not-supported-label');
            dv.style.color = '#063438';
            dv.style.fontSize = "17px";
            dv.innerHTML = `The file <strong>${file.name}</strong> is not supported.`;
            errorMessage.prepend(dv);
            errorMessage.classList.add('alert-warning');
            errorMessage.classList.remove('d-none');
        }
    }
}

function formatFileSize(size) {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB'];
    let formattedSize = size;
    let unitIndex = 0;

    while (formattedSize >= 1024 && unitIndex < units.length - 1) {
        formattedSize /= 1024;
        unitIndex++;
    }

    let sizeToDisplay = formattedSize < 0.01 ? 0 : formattedSize.toFixed(2);
    let result = `${sizeToDisplay} ${units[unitIndex]}`;
    return result;
}

function removeFile(index) {
    selectedFiles.splice(index, 1); 
    updateFileInput();
}

function updateFileInput() {
    const dataTransfer = new DataTransfer();
    selectedFiles.forEach((file) => dataTransfer.items.add(file));
    document.getElementById('pao-file-input').files = dataTransfer.files; 
    displayTotalFileSize();
}

function updateFileInputAfterDeleted(fileItem) {
    const dataTransfer = new DataTransfer();
    let input = document.getElementById('pao-file-input');
    let files = Array.from(input.files);

    const fileNameToRemove = fileItem.querySelector('.file-name').textContent.trim();

    selectedFiles = selectedFiles.filter(file => file.name !== fileNameToRemove);

    for (let file of files) {
        if (file.name !== fileNameToRemove) { 
            dataTransfer.items.add(file); 
        }
    }
    input.files = dataTransfer.files;
    displayTotalFileSize();
}

function displayTotalFileSize() {
    let totalBytes = selectedFiles.reduce((total, file) => total + file.size, 0); 
    let totalFormatted = formatFileSize(totalBytes); 

    let totalFileSizeLabel = document.getElementById('total_file_size');

    totalFileSizeLabel.textContent = `Total combined size: ${totalFormatted}`;

    let uploadButton = document.getElementById('pao-file-input');
    if (totalBytes > MAX_FILE_SIZE) {
        uploadButton.disabled = true; 
    } else {
        uploadButton.disabled = false; 
    }
}

function showScanningIndicator() {
    let container = document.getElementById('scanning-indicator-container');
    let loadingIndicator = document.getElementById('scanning-indicator');

    if (!container) {
        container = document.createElement('div');
        container.id = 'scanning-indicator-container';

        loadingIndicator = document.createElement('div');
        loadingIndicator.id = 'scanning-indicator';
        loadingIndicator.textContent = 'Scanning file. Please wait...';
        loadingIndicator.classList.add('scanning-indicator');

        container.appendChild(loadingIndicator);

        fileList.parentNode.insertBefore(container, fileList);  
    }

    container.style.display = 'flex';  
    loadingIndicator.style.display = 'block'; 
}

function hideScanningIndicator() {
    const loadingIndicator = document.getElementById('scanning-indicator-container');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
    }
}

if (dropArea) {

    dropArea.addEventListener('dragover', function (e) {
        e.preventDefault();
        dropArea.classList.add('hover');
    });

    dropArea.addEventListener('dragleave', function () {
        dropArea.classList.remove('hover');
    });

    dropArea.addEventListener('drop', function (e) {        
        e.preventDefault();
        dropArea.classList.remove('hover');
        const files = e.dataTransfer.files;
        notifyInvalidFileType(files);
        handleFilesAsync(files);
    });
}

browseLink.addEventListener('click', function (e) {
    e.preventDefault();
    fileInput.click();
});

fileInput.addEventListener('change', function () {


    let input = document.getElementById('pao-file-input');
    let files = input.files;
    notifyInvalidFileType(files);
    handleFilesAsync(files);
});